import { ArrowRight, Rocket, Sparkles } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/matthew-trottstudios';
const LOGO_URL = '/trott-logo.png';

export const CTA = () => {
  return (
    <section
      data-testid="cta-section"
      className="py-20 md:py-28 bg-[#FAFAFA] relative overflow-hidden"
    >
      {/* Background decorations */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-[#00D4FF]/10 rounded-full blur-3xl animate-blob" />
      <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-[#0EA5E9]/10 rounded-full blur-3xl animate-blob animation-delay-2000" />
      
      <div className="max-w-6xl mx-auto px-5 md:px-8 relative z-10">
        <div className="bg-[#1E1E2E] rounded-3xl p-10 md:p-14 relative overflow-hidden group hover:shadow-2xl hover:shadow-[#00D4FF]/10 transition-all duration-500">
          {/* Animated background */}
          <div className="absolute inset-0 grid-pattern opacity-10" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#00D4FF]/10 rounded-full blur-3xl group-hover:bg-[#00D4FF]/20 transition-all duration-700" />
          <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#0EA5E9]/10 rounded-full blur-3xl" />
          
          {/* Floating sparkles */}
          <Sparkles className="absolute top-8 right-8 text-[#00D4FF]/30 animate-float" size={32} />
          <Sparkles className="absolute bottom-8 left-8 text-[#00D4FF]/20 animate-float animation-delay-1000" size={24} />
          
          {/* Decorative shapes */}
          <div className="absolute top-10 right-20 w-20 h-20 border border-[#00D4FF]/20 rounded-2xl rotate-12 group-hover:rotate-45 transition-transform duration-700" />
          <div className="absolute bottom-10 left-20 w-12 h-12 border border-[#00D4FF]/20 rounded-full group-hover:scale-150 transition-transform duration-700" />
          
          <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            {/* Left side */}
            <div className="flex flex-col gap-4">
              <div className="relative">
                <img 
                  src={LOGO_URL} 
                  alt="TrottStudios" 
                  className="h-16 md:h-20 w-auto max-w-[280px] md:max-w-[360px] object-contain group-hover:scale-105 transition-transform duration-500" 
                />
              </div>
              <div>
                <h2
                  data-testid="cta-headline"
                  className="text-3xl md:text-4xl font-bold text-white mb-2"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                  Ready to <span className="text-gradient">grow?</span>
                </h2>
                <p className="text-base text-gray-400">
                  Let's talk about your project and make it happen.
                </p>
              </div>
            </div>
            
            {/* Right side - CTA button */}
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-button"
              className="group/btn relative inline-flex items-center justify-center gap-3 rounded-full px-10 py-5 text-lg font-semibold bg-[#00D4FF] text-[#1E1E2E] overflow-hidden transition-all duration-300 hover:scale-105 shadow-lg shadow-[#00D4FF]/30 hover:shadow-[#00D4FF]/50"
            >
              {/* Button shine effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700" />
              
              <Rocket size={20} className="group-hover/btn:rotate-12 transition-transform" />
              <span className="relative z-10">Book a Call</span>
              <ArrowRight size={20} className="group-hover/btn:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
